"use strict";
exports.__esModule = true;
exports.assignFromAccountRaw = exports.assignToAccountRaw = exports.fromNearResourcesRaw = exports.toNearResourcesRaw = void 0;
var bignumber_js_1 = require("bignumber.js");
function toNearResourcesRaw(r) {
    var stakedBalance = r.stakedBalance, pendingBalance = r.pendingBalance, availableBalance = r.availableBalance, storageUsageBalance = r.storageUsageBalance, stakingPositions = r.stakingPositions;
    return {
        stakedBalance: stakedBalance.toString(),
        pendingBalance: pendingBalance.toString(),
        availableBalance: availableBalance.toString(),
        storageUsageBalance: storageUsageBalance.toString(),
        stakingPositions: stakingPositions.map(function (_a) {
            var staked = _a.staked, validatorId = _a.validatorId, available = _a.available, pending = _a.pending, rewards = _a.rewards;
            return ({
                staked: staked.toString(),
                available: available.toString(),
                pending: pending.toString(),
                rewards: rewards.toString(),
                validatorId: validatorId
            });
        })
    };
}
exports.toNearResourcesRaw = toNearResourcesRaw;
function fromNearResourcesRaw(r) {
    var stakedBalance = r.stakedBalance, pendingBalance = r.pendingBalance, availableBalance = r.availableBalance, storageUsageBalance = r.storageUsageBalance, _a = r.stakingPositions, stakingPositions = _a === void 0 ? [] : _a;
    return {
        stakedBalance: new bignumber_js_1.BigNumber(stakedBalance),
        pendingBalance: new bignumber_js_1.BigNumber(pendingBalance),
        availableBalance: new bignumber_js_1.BigNumber(availableBalance),
        storageUsageBalance: new bignumber_js_1.BigNumber(storageUsageBalance),
        stakingPositions: stakingPositions.map(function (_a) {
            var staked = _a.staked, validatorId = _a.validatorId, available = _a.available, pending = _a.pending, rewards = _a.rewards;
            return ({
                staked: new bignumber_js_1.BigNumber(staked),
                available: new bignumber_js_1.BigNumber(available),
                pending: new bignumber_js_1.BigNumber(pending),
                rewards: new bignumber_js_1.BigNumber(rewards),
                validatorId: validatorId
            });
        })
    };
}
exports.fromNearResourcesRaw = fromNearResourcesRaw;
function assignToAccountRaw(account, accountRaw) {
    var nearAccount = account;
    if (nearAccount.nearResources) {
        accountRaw.nearResources = toNearResourcesRaw(nearAccount.nearResources);
    }
}
exports.assignToAccountRaw = assignToAccountRaw;
function assignFromAccountRaw(accountRaw, account) {
    var nearResourcesRaw = accountRaw.nearResources;
    if (nearResourcesRaw)
        account.nearResources =
            fromNearResourcesRaw(nearResourcesRaw);
}
exports.assignFromAccountRaw = assignFromAccountRaw;
//# sourceMappingURL=serialization.js.map